module.exports = __webpack_public_path__ + "static/media/6630.cfa3b99e.jpg";